import {Directive, ElementRef, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';

@Directive({
  selector: '[appScrollToElement]',
})
export class ScrollToElementDirective implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private pendingElementId: string | null = null;

  constructor(
    private elementRef: ElementRef,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.fragment.pipe(takeUntil(this.destroy$)).subscribe(anchor => {
      if (anchor) {
        this.pendingElementId = anchor;
        if (this.elementRef.nativeElement.children.length > 0) {
          this.scrollToElement(anchor);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.pendingElementId) {
      this.scrollToElement(this.pendingElementId);
      this.pendingElementId = null;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private scrollToElement(elementId: string): void {
    const targetElement = this.elementRef.nativeElement.querySelector(`#${elementId}`);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } else {
      console.warn(`Element with id "${elementId}" not found in the DOM`);
    }
  }
}
